import React, { useState } from 'react';
//@ts-ignore
import * as styles from './product-specifications.module.css';
import {
    KontentStringValue,
    KontentRichText,
    KontentImageUrl,
} from '../../../types/KontentProps';
import RichText from '../Global/RichText';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import SvgDownArrowSm from '../Global/ShowMoreArrow/SvgDownArrowSm';

type categoryMeasurements = {
    elements: {
        value: KontentStringValue;
        title: KontentStringValue;
        weight: KontentStringValue;
        measurement_content: KontentRichText;
        small_sub_copy: KontentRichText;
    };
};

type categoryIcon = {
    elements: {
        icon_svg_file: KontentImageUrl;
        color: {
            value: {
                codename: string;
            };
        };
    };
};
export interface Specifications {
    category_1_headline: KontentStringValue;
    category_1_icon: categoryIcon;
    category_1_measurements: categoryMeasurements[];
    category_2_headline: KontentStringValue;
    category_2_icon: categoryIcon;
    category_2_measurements: categoryMeasurements[];
    category_3_headline: KontentStringValue;
    category_3_icon: categoryIcon;
    category_3_measurements: categoryMeasurements[];
    category_4_headline: KontentStringValue;
    category_4_icon: categoryIcon;
    category_4_measurements: categoryMeasurements[];
    category_5_headline: KontentStringValue;
    category_5_icon: categoryIcon;
    category_5_measurements: categoryMeasurements[];
    category_6_headline: KontentStringValue;
    category_6_icon: categoryIcon;
    category_6_measurements: categoryMeasurements[];
}

interface Props {
    specifications: {
        value: {
            elements: Specifications;
        };
    };
}

const ProductSpecsList: React.FC<Props> = ({ specifications }) => {
    const breakpoints = useBreakpoint();
    const [visibleCategories, setVisibleCategories] = useState({});

    const toggleCategory = (categoryNumber) => {
        setVisibleCategories({
            ...visibleCategories,
            [categoryNumber]: !visibleCategories[categoryNumber],
        });
    };

    return (
        <>
            {!breakpoints.sm && <hr className={styles.hrlinefirst} />}
            <ul className={styles.specData}>
                {[1, 2, 3, 4, 5, 6].map((categoryNumber) => {
                    const isCatVisible = !!visibleCategories[categoryNumber];
                    return (
                        <li
                            className={`${styles.spec} ${
                                isCatVisible && !breakpoints.sm
                                    ? styles.greyback
                                    : ''
                            }`}
                            key={categoryNumber}
                        >
                            {!breakpoints.sm ? (
                                <div
                                    className={`${styles.rowClose} ${
                                        isCatVisible ? styles.rowOpen : ''
                                    }`}
                                    onClick={() =>
                                        toggleCategory(categoryNumber)
                                    }
                                >
                                    <h3>
                                        {
                                            specifications.value[0]?.elements[
                                                `category_${categoryNumber}_headline`
                                            ]?.value
                                        }
                                    </h3>
                                    {!breakpoints.sm && (
                                        <SvgDownArrowSm
                                            strokeColor={
                                                isCatVisible
                                                    ? '#f06623'
                                                    : '#505251'
                                            }
                                            transform={'0'}
                                            strokeWidth={5}
                                        />
                                    )}
                                </div>
                            ) : (
                                <h3>
                                    {
                                        specifications.value[0]?.elements[
                                            `category_${categoryNumber}_headline`
                                        ]?.value
                                    }
                                </h3>
                            )}
                            {(breakpoints.sm || isCatVisible) && (
                                <>
                                    {specifications.value[0]?.elements[
                                        `category_${categoryNumber}_icon`
                                    ]?.value[0]?.elements &&
                                        breakpoints.sm && (
                                            <img
                                                src={
                                                    specifications.value[0]
                                                        ?.elements[
                                                        `category_${categoryNumber}_icon`
                                                    ]?.value[0]?.elements
                                                        .icon_svg_file.value[0]
                                                        ?.url
                                                }
                                                alt=""
                                            />
                                        )}

                                    {specifications.value[0]?.elements[
                                        `category_${categoryNumber}_measurements`
                                    ]?.value.map(
                                        (measurements: any, index: number) => (
                                            <React.Fragment key={index}>
                                                {measurements.elements
                                                    .weight && (
                                                    <p>
                                                        {measurements.elements
                                                            ?.material?.value[0]
                                                            ?.elements
                                                            ?.name_for_display
                                                            ?.value
                                                            ? measurements
                                                                  .elements
                                                                  .material
                                                                  .value[0]
                                                                  .elements
                                                                  .name_for_display
                                                                  .value
                                                            : ''}{' '}
                                                        Weight:{' '}
                                                        {
                                                            measurements
                                                                .elements.weight
                                                                ?.value
                                                        }
                                                    </p>
                                                )}
                                                {measurements.elements
                                                    .measurement_content && (
                                                    <div>
                                                        {RichText(
                                                            measurements
                                                                .elements
                                                                .measurement_content,
                                                            undefined,
                                                            undefined,
                                                            undefined,
                                                            'measurement_content'
                                                        )}
                                                    </div>
                                                )}

                                                {measurements.elements
                                                    .title && (
                                                    <p>
                                                        {
                                                            measurements
                                                                .elements.title
                                                                ?.value
                                                        }
                                                        :{' '}
                                                        {
                                                            measurements
                                                                .elements.value
                                                                ?.value
                                                        }
                                                        <span
                                                            className={
                                                                styles.smallText
                                                            }
                                                        >
                                                            {
                                                                measurements
                                                                    .elements
                                                                    .small_sub_copy
                                                                    ?.value
                                                            }
                                                        </span>
                                                    </p>
                                                )}
                                            </React.Fragment>
                                        )
                                    )}
                                </>
                            )}

                            {!breakpoints.sm && (
                                <hr className={styles.hrLineSec} />
                            )}
                        </li>
                    );
                })}
            </ul>
        </>
    );
};

export default ProductSpecsList;
